module.exports = __webpack_public_path__ + "img/selected1-min.b7e42bcc.png";